// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalNext_modal__1z4NE","modalLayout":"ModalNext_modalLayout__12k9Y","overlay":"ModalNext_overlay__1OBqB"};